var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("分播机器列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { type: "primary" },
              on: { click: _vm.beforeAddMachine }
            },
            [_vm._v("\n      新增\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "max-height": "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "machine_id",
                            label: "设备id"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "machine_no",
                            label: "设备编号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "grid_num",
                            label: "格口数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", prop: "ip", label: "ip" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "port",
                            label: "端口号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "admin_name",
                            label: "更新人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "update_time",
                            label: "更新时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "grid_is_check_one_out",
                            label: "一键打包"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editMachine(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("修改\n              ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#f56c6c" },
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.delMachine(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("删除\n              ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3819952090
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.visible
        ? _c("edit", {
            attrs: {
              machine_id: _vm.form.machine_id,
              machine_no: _vm.form.machine_no,
              grid_num: _vm.form.grid_num,
              ip: _vm.form.ip,
              port: _vm.form.port,
              is_check_one_out: _vm.form.is_check_one_out
            },
            on: { onCloseDialog: _vm.closeBox }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("分播方案配置")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "machine_cut_case_setting" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.machine_cut_case_setting, inline: "" }
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择设备" },
                      on: { change: _vm.getCutCase },
                      model: {
                        value: _vm.machine_cut_case_setting.machine_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.machine_cut_case_setting,
                            "machine_id",
                            $$v
                          )
                        },
                        expression: "machine_cut_case_setting.machine_id"
                      }
                    },
                    _vm._l(_vm.resData.list, function(item) {
                      return _c("el-option", {
                        key: item.machine_id,
                        attrs: {
                          value: item.machine_id,
                          label: item.machine_no
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择分播类型" },
                      on: { change: _vm.getCutCase },
                      model: {
                        value: _vm.machine_cut_case_setting.machine_cut_type,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.machine_cut_case_setting,
                            "machine_cut_type",
                            $$v
                          )
                        },
                        expression: "machine_cut_case_setting.machine_cut_type"
                      }
                    },
                    _vm._l(_vm.resData.machine_cut_type, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "50px" },
                      attrs: { type: "danger" },
                      on: { click: _vm.setCaseName }
                    },
                    [_vm._v("增加分播方案\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.machine_cut_case_setting.machine_cut_type ===
              _vm.DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showBindPrinter }
                        },
                        [_vm._v("绑定打印机\n        ")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.machine_cut_case_setting.machine_cut_type !==
              _vm.DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
                ? [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveCutCase }
                          },
                          [_vm._v("保存")]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            _vm._l(_vm.machine_cut_case_setting.case, function(item, key) {
              return _c(
                "el-col",
                { key: key, attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _vm.machine_cut_case_setting.machine_cut_type ===
                          _vm.DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION
                            ? _c(
                                "span",
                                [
                                  _vm._v(
                                    "\n              入库分播包裹号必填\n              "
                                  ),
                                  _c("el-switch", {
                                    attrs: {
                                      "active-color": "#409EFF",
                                      "inactive-color": "#999",
                                      "active-value": "1",
                                      "inactive-value": "0"
                                    },
                                    model: {
                                      value:
                                        _vm.machine_cut_case_setting.case[0]
                                          .is_need_package,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.machine_cut_case_setting.case[0],
                                          "is_need_package",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "machine_cut_case_setting.case[0].is_need_package"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.machine_cut_case_setting.machine_cut_type ===
                              _vm.DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      refInFor: true,
                                      staticStyle: { display: "inline-flex" },
                                      attrs: {
                                        action: _vm.action,
                                        name: "excel",
                                        limit: 1,
                                        "show-file-list": false,
                                        multiple: false,
                                        data: {
                                          machine_cut_type:
                                            _vm.machine_cut_case_setting
                                              .machine_cut_type,
                                          machine_id:
                                            _vm.machine_cut_case_setting
                                              .machine_id,
                                          case_name: item.case_name,
                                          case_id: item.case_id
                                        },
                                        "with-credentials": "",
                                        "on-success": _vm.handleUploadResult
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary"
                                          }
                                        },
                                        [_vm._v("导入")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showConfig(item)
                                        }
                                      }
                                    },
                                    [_vm._v("配置")]
                                  )
                                ],
                                1
                              )
                            : _c("span", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "font-size": "20px",
                                "font-weight": "800",
                                float: "right",
                                padding: "3px 0"
                              },
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.rename(key)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(item.case_name) + "\n              "
                              ),
                              _c("i", {
                                staticClass: "el-icon-edit",
                                staticStyle: { "font-size": "20px" }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        { attrs: { data: item.grid_setting, border: "" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "grid_no",
                              label: "格口号",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          [
                            _vm.DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
                          ].includes(
                            _vm.machine_cut_case_setting.machine_cut_type
                          )
                            ? [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "method_text",
                                    label: "分播方式",
                                    align: "center"
                                  }
                                })
                              ]
                            : [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "cut_type",
                                    label: "分播类型",
                                    align: "center"
                                  }
                                })
                              ],
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n                格口配置\n                "
                                      ),
                                      ![
                                        _vm.DISTRIBUTION_TYPE
                                          .INBOUND_DISTRIBUTION,
                                        _vm.DISTRIBUTION_TYPE
                                          .MEDIAN_DISTRIBUTION_GROUP,
                                        _vm.DISTRIBUTION_TYPE
                                          .RETURN_DISTRIBUTION_GROUP
                                      ].includes(
                                        _vm.machine_cut_case_setting
                                          .machine_cut_type
                                      )
                                        ? _c("i", {
                                            staticClass: "el-icon-close",
                                            staticStyle: {
                                              color: "#f00",
                                              float: "right",
                                              "font-size": "20px",
                                              "font-weight": "800",
                                              cursor: "pointer"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeCase(key)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      [
                                        "1",
                                        "2",
                                        "4",
                                        _vm.DISTRIBUTION_TYPE
                                          .MEDIAN_DISTRIBUTION_GROUP
                                      ].includes(
                                        _vm.machine_cut_case_setting
                                          .machine_cut_type
                                      )
                                        ? _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                value: scope.row.grid_type,
                                                disabled: ["1", "2"].includes(
                                                  scope.row.is_sc_grid
                                                ),
                                                size: "small",
                                                filterable: "",
                                                multiple: ["2", "4"].includes(
                                                  _vm.machine_cut_case_setting
                                                    .machine_cut_type
                                                ),
                                                placeholder: "请选择"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.onGridTypeChange(
                                                    $event,
                                                    key,
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(
                                              _vm.machine_grid_type[
                                                _vm.machine_cut_case_setting
                                                  .machine_cut_type
                                              ],
                                              function(gt) {
                                                return _c("el-option", {
                                                  key: gt.value,
                                                  attrs: {
                                                    value: gt.value,
                                                    label: gt.label
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        : [
                                            _vm.DISTRIBUTION_TYPE
                                              .RETURN_DISTRIBUTION_GROUP
                                          ].includes(
                                            _vm.machine_cut_case_setting
                                              .machine_cut_type
                                          )
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.method_type_text
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _c("el-cascader", {
                                            attrs: {
                                              filterable: "",
                                              options:
                                                _vm.machine_grid_type[
                                                  _vm.machine_cut_case_setting
                                                    .machine_cut_type
                                                ],
                                              "show-all-levels": false,
                                              props: {
                                                expandTrigger: "hover",
                                                multiple: true
                                              }
                                            },
                                            model: {
                                              value: scope.row.grid_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "grid_type",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.grid_type"
                                            }
                                          })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _vm.machine_cut_case_setting.machine_cut_type ===
                            _vm.DISTRIBUTION_TYPE.INBOUND_DISTRIBUTION ||
                          _vm.machine_cut_case_setting.machine_cut_type ===
                            _vm.DISTRIBUTION_TYPE.MEDIAN_DISTRIBUTION_GROUP
                            ? _c("el-table-column", {
                                attrs: { width: "120" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function() {
                                        return [
                                          _vm._v(
                                            "\n                格口件数上限(仅限正常标)\n                "
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-close",
                                            staticStyle: {
                                              color: "#f00",
                                              "font-size": "20px",
                                              "font-weight": "800",
                                              cursor: "pointer",
                                              position: "absolute",
                                              rigth: "0",
                                              top: "0"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeCase(key)
                                              }
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          scope.row.grid_type == 1 ||
                                          _vm.machine_cut_case_setting
                                            .machine_cut_type ===
                                            _vm.DISTRIBUTION_TYPE
                                              .MEDIAN_DISTRIBUTION_GROUP
                                            ? _c("el-input-number", {
                                                staticStyle: { width: "90px" },
                                                attrs: {
                                                  controls: false,
                                                  size: "small",
                                                  min: 0
                                                },
                                                model: {
                                                  value: scope.row.max_cut_num,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "max_cut_num",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.max_cut_num"
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          [2, 4].includes(
                            Number(
                              _vm.machine_cut_case_setting.machine_cut_type
                            )
                          )
                            ? _c("el-table-column", {
                                attrs: {
                                  label: _vm.showOther
                                    ? "其他配置"
                                    : "不出库格口",
                                  align: "center",
                                  width: "100"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm.showOther
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        value:
                                                          scope.row.is_sc_grid,
                                                        clearable: ""
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.selectScGrid(
                                                            $event,
                                                            scope.row,
                                                            item.grid_setting
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("el-option", {
                                                        attrs: {
                                                          label: "色差",
                                                          value: "1"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-option", {
                                                        attrs: {
                                                          label: "微次",
                                                          value: "2"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-option", {
                                                        attrs: {
                                                          label: "不出库格口",
                                                          value: "3"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("el-checkbox", {
                                                    attrs: {
                                                      "true-label": "1",
                                                      "false-label": "0"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.checkScGrid(
                                                          $event,
                                                          item.grid_setting,
                                                          scope.$index
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.is_sc_grid,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "is_sc_grid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.is_sc_grid"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          [
                            _vm.DISTRIBUTION_TYPE.RETURN_DISTRIBUTION_GROUP
                          ].includes(
                            _vm.machine_cut_case_setting.machine_cut_type
                          )
                            ? _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  width: "100",
                                  label: "其他配置",
                                  prop: "grid_type"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "line-2" },
                                            [_vm._v(_vm._s(row.grid_type))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "配置",
            visible: _vm.configDialogVisible,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.configDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { model: _vm.configForm, "label-width": "180px" }
            },
            [
              _c("el-checkbox", {
                model: {
                  value: _vm.configForm.autoCheck,
                  callback: function($$v) {
                    _vm.$set(_vm.configForm, "autoCheck", $$v)
                  },
                  expression: "configForm.autoCheck"
                }
              }),
              _vm._v("\n      商家细分释放格口是否自动完成校验\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { model: _vm.configForm, "label-width": "180px" } },
            [
              _c("el-checkbox", {
                model: {
                  value: _vm.configForm.enableLimit,
                  callback: function($$v) {
                    _vm.$set(_vm.configForm, "enableLimit", $$v)
                  },
                  expression: "configForm.enableLimit"
                }
              }),
              _vm._v("\n      是否限制商品数量上限，默认值为\n      "),
              _c("el-input-number", {
                staticStyle: { width: "120px" },
                attrs: {
                  size: "small",
                  min: 1,
                  max: 999999999,
                  precision: 0,
                  step: 1,
                  controls: true,
                  "controls-position": "right"
                },
                on: {
                  input: function($event) {
                    _vm.configForm.limit = Math.floor(
                      Math.abs(_vm.configForm.limit)
                    )
                  }
                },
                model: {
                  value: _vm.configForm.limit,
                  callback: function($$v) {
                    _vm.$set(_vm.configForm, "limit", $$v)
                  },
                  expression: "configForm.limit"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.configDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfigSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定打印机",
            visible: _vm.printerDialogVisible,
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.printerDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "transfer-container" },
            [
              _c(
                "div",
                { staticStyle: { width: "300px" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { data: _vm.printerList, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "打印机名称", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n              打印机名称\n              "
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: { type: "primary", size: "small" },
                                    on: { click: _vm.showAddPrinter }
                                  },
                                  [_vm._v("新增")]
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "default",
                            fn: function(ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c("i", {
                                        staticClass: "el-icon-close",
                                        staticStyle: {
                                          color: "#f56c6c",
                                          cursor: "pointer",
                                          "margin-right": "10px",
                                          "font-size": "20px"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deletePrinter(row)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            color:
                                              _vm.activeEditPrinterId &&
                                              _vm.activeEditPrinterId !== row.id
                                                ? "#ddd"
                                                : "inherit"
                                          }
                                        },
                                        [_vm._v(_vm._s(row.printer_name))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          gap: "8px"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.handleEditMode(row)
                                              }
                                            }
                                          },
                                          [_vm._v("编辑")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.editPrinter(row)
                                              }
                                            }
                                          },
                                          [_vm._v("修改")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-transfer", {
                ref: "cityTransfer",
                attrs: {
                  filterable: "",
                  titles: ["已绑定格口", "未绑定格口"],
                  data: _vm.transferData,
                  "target-order": "push"
                },
                on: { change: _vm.handleTransferChange },
                model: {
                  value: _vm.transferBinds,
                  callback: function($$v) {
                    _vm.transferBinds = $$v
                  },
                  expression: "transferBinds"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClosePrinterModal } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.savePrinterBinding }
                },
                [_vm._v("保 存")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editingPrinter ? "修改打印机" : "新增打印机",
            visible: _vm.addPrinterVisible,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addPrinterVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.printerForm, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设备名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入打印机名称" },
                    model: {
                      value: _vm.printerForm.printer_name,
                      callback: function($$v) {
                        _vm.$set(_vm.printerForm, "printer_name", $$v)
                      },
                      expression: "printerForm.printer_name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addPrinterVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAddPrinter }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb21ab2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb21ab2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/machine/machineList.vue
// module id = null
// module chunks = 